import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
	selector: 'app-switch-control',
	imports: [CommonModule, FormsModule, ReactiveFormsModule],
	templateUrl: './switch-control.component.html',
	styleUrl: './switch-control.component.scss',
})
export class SwitchControlComponent<T extends { [K in keyof T]: AbstractControl }> {
	@Input() formGroup!: FormGroup<T>;
	@Input() name!: Extract<keyof T, string | number>;
	@Input() label?: string;

	randomId = Math.random().toString(36).substring(2);
}
